import AgentLayout from './AgentLayout';
import VerificationPanelList from './verification/VerificationPanelList';

function AgentVerification() {
  return (
    <AgentLayout>
      <VerificationPanelList
        apiPrefix="/agent/verification"
        detailPathPrefix="/agent/verification"
      />
    </AgentLayout>
  );
}

export default AgentVerification;